
import _ from 'lodash';
import { connect } from 'react-redux';
import { IRootState } from 'redux/root_reducer';

import { toggleFilterView } from 'redux/modules/inventory_filter_data';

import InventoryFilterInputs, { DispatchProps, OwnProps, StateProps } from 'components/pages/inventory/InventoryFilterInputs';

const maptStateToProps = (state: IRootState): StateProps => {
    return {
        category_options: state.inventory_filter_data.categories,
        get_options: state.inventory.get_options,
        isMobile: state.display.isMobile,
        isSearching: state.inventory.isSearching,
        itemsFound: _.get(state, 'inventory.response_data.total'),
        manufacturers: state.inventory_filter_data.manufacturers,
        models: state.inventory_filter_data.models,
        viewFilters: state.inventory_filter_data.viewFilters,
        years: state.inventory_filter_data.years,
    };
};

const mapDispatchToProps = (dispatch: any): DispatchProps => {
    return {
        toggleFilterView: (viewFilters: any) => dispatch(toggleFilterView(viewFilters))
    };
};

export default connect<StateProps, {}, OwnProps>(maptStateToProps, mapDispatchToProps)(InventoryFilterInputs);



// WEBPACK FOOTER //
// ./src/containers/pages/inventory/InventoryFilterInputs.tsx